<template>
  <browse-filter name="Avg customer rating">
    <browse-filter-radio
      v-for="r in Array(4,3,2,1)"
      :key="r"
      label="r"
      name="average_rating"
      :value="String(r)"
      :checked="Number(value) === Number(r)"
      @click="select"
    >
      <template #label>
        <div class="rating">
          <div class="taco-rating">
            <span :style="tacoRatingStyle(r)" />
          </div>
          <span>&amp; up</span>
        </div>
      </template>
    </browse-filter-radio>
    <browse-filter-radio
      label="Any"
      name="average_rating"
      value="0"
      :checked="!value"
      @click="select"
    >
      <template #label>
        <div class="rating">
          <div class="taco-rating">
            <span :style="tacoRatingStyle(0)" />
          </div>
          <span>Any</span>
        </div>
      </template>
    </browse-filter-radio>
  </browse-filter>
</template>
<script>
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterRadio from './BrowseFilterRadio.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterRadio,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
    tacoRatingStyle(r) {
      return {
        width: `${(r * 19)}%`,
      };
    },
  },
};
</script>
<style scoped lang="scss">
.rating {
  display: flex;
  align-items: center;

  >span {
    font-size: 12px;
    color: #1b1b1b;
  }
}

.taco-rating {
  position: relative;
  height: 12px;

  &::before,
  > span {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: auto 100%;
  }

  &::before {
    background-image: url(~/static/partners/0-tacos.svg);
  }

  > span {
    background-image: url(~/static/partners/5-tacos.svg);
  }
}
</style>
